<template>
    <div>
        <div class="media-page">
            <div class="header-overlay">
                <div class="header-text" style="padding-top: 100px;">最新動向</div>
            </div>
        </div>

        <div class="container-fluid" style="margin-top: 8px; padding: 0 8px 20px 8px;">
            <div class="row g-2">
                <div class="col-12 col-md-4 news-wrapper" v-for="(row, index) in newsDataSource" v-bind:key="index">
                    <!--<div class="news-wrapper-2" v-bind:style="getNewsBackgroundImage(row.cover)">-->
                    <div class="news-wrapper-2" v-on:click="loadDetail(row.id)">
                        <div class="news-wrapper-2-overlay">
                            <div class="text-wrapper">
                                <div style="font-size: 1.5em; letter-spacing: 5px;">{{row.name}}</div>
                                <div style="width: 100%; height: 1px; border-bottom: 1px solid #fff; margin: 10px 0 10px 0;"></div>
                                <div style="letter-spacing: 2px;">{{row.subName}}</div>
                                <div style="letter-spacing: 2px; padding-top: 8px;">{{row.date}}</div>
                            </div>
                        </div>
                        <div class="news-wrapper-2-overlay-2" v-bind:style="getNewsBackgroundImage(row.cover)">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="popup-overlay" v-bind:style="heightPx" v-if="clickedNewsId != null" v-on:click="popupCloseButtonClick">

            <div class="news-window" @click.stop="">
                <div style="position: sticky; width: 100%; height: 65px; background-color: #fff; top: 0; z-index: 1000002;">
                    <div style="position: absolute; top: 0; right: 0; width: 65px; height: 65px; padding: 20px;">
                        <img style="width: 100%; height: 100%; cursor: pointer;" src="../assets/close.png" v-on:click="popupCloseButtonClick" />
                    </div>
                </div>

                <div style="margin-top:0px; position: relative;">
                    <div style="width: 100%;">

                        <div style="width: 100%; height: auto; position: relative; padding: 5px;" v-for="(atth, index) in newsDetail.attachment" v-bind:key="index">
                            <a v-bind:href="getAttachmentPath(atth.a_path)" target="_blank" style="cursor: zoom-in;"><img v-bind:src="getAttachmentPath(atth.a_path)" style="width: 100%; height: auto;" /></a>
                        </div>
                        <div v-html="newsDetail.description" style="margin-top: 10px;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {
        GET_NEWS_API_PATH, GET_MEDIA_OR_NEWS_DETAIL_API_PATH
    } from '../constants';

    export default {
        name: "Nes",
        methods: {
            reloadData: function () {

                let that = this;

                axios.post(GET_NEWS_API_PATH)
                    .then(function (res) {
                        that.newsDataSource = res.data;
                    }).catch(function (ex) {
                        that.newsDataSource = [];
                    });
            },
            loadDetail: function (newsId) {

                this.clickedNewsId = newsId;

                let that = this;
                let postData = { newsId: newsId };

                axios.post(GET_MEDIA_OR_NEWS_DETAIL_API_PATH, postData)
                    .then(function (res) {
                        that.newsDetail = res.data;
                    }).catch(function (ex) {
                        that.newsDetail = null;
                    });
            },
            getNewsBackgroundImage: function (path) {

                if (path == null)
                    return "";

                let style = 'background-image: url("/' + path + '"); background-size: cover; background-position: center;';
                return style;
            },
            getAttachmentPath: function (path) {
                return "/" + path;
            },
            popupCloseButtonClick: function () {
                this.clickedNewsId = null;
            }
        },
        created: async function () {

            this.reloadData();
        },
        data() {
            return {
                newsDataSource: [],
                clickedNewsId: null,
                newsDetail: null
            };
        },
        computed: {
            heightPx: function () {
                let style = 'min-height: ' + (this.$globalData.windowHeight) + 'px;';
                return style;
            }
        }
    };
</script>
